import React, { useState } from 'react';
import { storageService } from '../../services/storageService';

interface IconUploadProps {
  value: string;
  onChange: (url: string) => void;
}

export const IconUpload: React.FC<IconUploadProps> = ({ value, onChange }) => {
  const [isUploading, setIsUploading] = useState(false);
  const [previewUrl, setPreviewUrl] = useState<string | null>(value || null);

  // Update preview when value changes externally
  React.useEffect(() => {
    setPreviewUrl(value || null);
  }, [value]);

  const handleFileSelect = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;

    if (!file.type.startsWith('image/')) {
      alert('Vui lòng chọn file ảnh');
      return;
    }

    setIsUploading(true);
    
    try {
      const uploadedUrl = await storageService.uploadFile(file);
      onChange(uploadedUrl);
      setPreviewUrl(uploadedUrl);
    } catch (error) {
      console.error('Error uploading icon:', error);
      alert('Không thể tải lên icon. Vui lòng thử lại.');
    } finally {
      setIsUploading(false);
    }
  };

  const handleRemove = () => {
    onChange('');
    setPreviewUrl(null);
  };

  return (
    <div className="space-y-3">
      {previewUrl && (
        <div className="relative inline-block">
          <img
            src={previewUrl}
            alt="Badge icon preview"
            className="w-20 h-20 rounded-full object-cover border-2 border-gray-200"
          />
          <button
            type="button"
            onClick={handleRemove}
            className="absolute -top-2 -right-2 bg-red-500 text-white rounded-full w-6 h-6 flex items-center justify-center hover:bg-red-600 transition-colors"
          >
            ×
          </button>
        </div>
      )}
      
      <label className="flex items-center justify-center w-full px-4 py-3 border-2 border-dashed border-gray-300 rounded-lg cursor-pointer hover:border-indigo-500 transition-colors">
        {isUploading ? (
          <div className="flex items-center space-x-2 text-gray-600">
            <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-indigo-600"></div>
            <span className="text-sm">Đang tải lên...</span>
          </div>
        ) : (
          <div className="flex flex-col items-center space-y-2">
            <svg className="w-6 h-6 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
            </svg>
            <span className="text-sm text-gray-600">
              {previewUrl ? 'Thay đổi icon' : 'Tải lên icon'}
            </span>
          </div>
        )}
        <input
          type="file"
          className="hidden"
          accept="image/*"
          onChange={handleFileSelect}
          disabled={isUploading}
        />
      </label>
      
    </div>
  );
};

